export interface SelectableParameter {
    label: string;
    value: string;
}

// Assuming the definitions from the previous response:
/*
enum ExerciseChartValueEnum { WEIGHT, REPS, MAX, MIN, AVG, TONS, SETS }
export interface SelectableTimeframe { label: string; value: string; }
*/

export const selectableParameters: SelectableParameter[] = [
  {
    "label": "AVG Weight",
    "value": "WEIGHT"
  },
  {
    "label": "MAX weight",
    "value": "MAX_WGT"
  },
  {
    "label": "MIN weight",
    "value": "MIN_WGT"
  },
  {
    "label": "Min reps", // Corresponds to ExerciseChartValueEnum.MIN
    "value": "MIN_REPS"
  },
  {
    "label": "AVG reps", // Corresponds to ExerciseChartValueEnum.MIN
    "value": "AVG_REPS"
  },
  {
    "label": "MAX reps", // Corresponds to ExerciseChartValueEnum.MIN
    "value": "MAX_REPS"
  },
  {
    "label": "Tons", // Corresponds to ExerciseChartValueEnum.TONS
    "value": "TONS"
  },
  {
    "label": "Volume", // Corresponds to ExerciseChartValueEnum.SETS
    "value": "SETS"
  },
  {
    "label": "1RM", // Corresponds to ExerciseChartValueEnum.SETS
    "value": "1RM"
  }
];